import { collection, query, getDocs, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';

export async function searchSongsByTitle(term, max = 20) {
    if (!term || term.trim().length === 0) return [];
    const songsCol = collection(db, 'songs');
    // Firestore doesn't support contains/ILIKE; use range query on a lowercase title field if available
    // Fallback: fetch a few recent songs and filter client-side by title
    try {
        const q = query(songsCol, orderBy('createdAt', 'desc'), limit(200));
        const snaps = await getDocs(q);
        const results = snaps.docs
            .map(d => ({ id: d.id, ...d.data() }))
            .filter(s => (s.title || '').toLowerCase().includes(term.toLowerCase()));
        return results.slice(0, max);
    } catch (err) {
        console.error('searchSongsByTitle error', err);
        return [];
    }
}
